/*
Version 0.115

Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
Copyright 2016 - 2018.

!Changelog

2021
	20-01-2021
	- [BORN] This class is born. Hooray!

!Usage
	specific_mobilemenu.onready();

	
!Wishlist

	none
	
*/
  
var specific_whatweknow = {};

(function(){
	 
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************

	this.onready = function() {

		/*
		Click to open popup
		*/
		$(document).on('click','.js-whatweknow',function() {
			
			popup.open(1,1,'whatweknow');

			if(_marcsenseretain_active == 1) {
				
				/*
		    	Scroll percentage
		    	*/
		    	var scrollTop 				= $(window).scrollTop();
				var docHeight 				= $(document).height();
				var winHeight 				= $(window).height();
				var scrollPercent 			= (scrollTop) / (docHeight - winHeight);
				var scrollPercentRounded 	= Math.round(scrollPercent*100);

				window.celebrusSendJsonData(
			    	{"events":[
			    		{
			    			"eventType" 	: "PageDepthEvent",
			    			"eventGroup"	: "Scenario",

			    			"ViewDepth" 	: scrollPercentRounded,
			    			"ViewedElement"	: 'Open popup: Wat we weten over jou'
			    		}
			    	]
				},2);

			}

		});
		
	};
	 
	// METHODS  *****************************************************************
	// METHODS *****************************************************************
	// METHODS ******************************************************************
	// METHODS ******************************************************************
	
	this.change = function(
		_percentage
	) {
		var _text = '';

		/*
		Show
		*/
		specific_whatweknow.show();

		/*
		Text
		*/
		if(_percentage <= 10) {
			_text = 'Op basis van je snelheid, klikgedrag en muisafstand voorspelt onze software dat er ' + _percentage + '% kans is dat je voortijdig afhaakt. Dat betekent dat je lager scoort dan 3/4 van de bezoekers en dus interesse hebt. Op dit moment zou onze software MarcSense Retain je met rust laten.';
		}

		if(_percentage > 10 && _percentage <= 27) {
			_text = 'Op basis van je snelheid, klikgedrag en muisafstand voorspelt onze software dat er ' + _percentage + '% kans is dat je voortijdig afhaakt. Dat betekent dat je bij de meest geïnteresseerde helft van de bezoekers zit en dus interesse hebt.';
		}

		if(_percentage > 27 && _percentage <= 60) {
			_text = 'Op basis van je snelheid, klikgedrag en muisafstand voorspelt onze software dat er ' + _percentage + '% kans is dat je voortijdig afhaakt. Dat betekent dat je bij de minst geïnteresseerde helft van de bezoekers zit en dus weinig interesse hebt. ';
		}

		if(_percentage > 60) {
			_text = 'Op basis van je snelheid, klikgedrag en muisafstand voorspelt onze software dat er ' + _percentage + '% kans is dat je voortijdig afhaakt. Dat betekent dat je heel weinig interesse hebt en grote kans dat je afhaakt. Op dit moment zou onze software MarcSense Retain zeker gaan personaliseren.';
		}

		/*
		Change text
		*/
		$('.js-whatweknow-text').html(
			_text
		);

	};

	this.show = function() {

		if(_whatweknow_shown == 0) {
			
			/*
			Show
			*/    
		    $('.js-whatweknow').animate({
		    	'bottom':'0px'
		    },800);

			/*
			Set
			*/
			_whatweknow_shown = 1;
		}

	};

	this.hide = function() {

		if(_whatweknow_shown == 1) {
			
			/*
			Show
			*/    
		    $('.js-whatweknow').animate({
		    	'bottom':'-200px'
		    },800);

			/*
			Set
			*/
			_whatweknow_shown = 0;
		}

	};


		
}).apply(specific_whatweknow); 